export const REG_CARD = /card\b/;
export const REG_DISABLE = /disable/;